import axios from "axios";
import api from "./api";

export interface RegisterNotificationDto {
  userId: string;
  deviceToken: string;
  categories?: string[];
  isEnabled?: boolean;
}

export const notificationService = {
  /**
   * Register or update user push token and category preferences in MongoDB
   */
  async registerDevice(data: RegisterNotificationDto) {
    const response = await api.post(`/notifications/register`, data);
    return response.data;
  },

  /**
   * Fetch all notification preferences / device tokens for a user
   */
  async getUserPreferences(userId: string) {
    const response = await axios.get(`/notifications/user/${userId}`);
    return response.data;
  },
};
